import { ProjectContents } from '@console/common/constants';
import BulkTable from '@console/components/project/selectionReport/BulkTable';
import type { AppState } from '@console/reducers';
import { getGifteeBoxConfigs } from '@console/selectors/projectDetail/gifteeBoxConfigs';
import { connect } from 'react-redux';
import type { NavigateFunction } from 'react-router';

const mapStateToProps = (state: AppState) => ({
  gifteeBoxConfigs: getGifteeBoxConfigs(state),
  onClickGifteeBoxConfig: (
    navigate: NavigateFunction,
    gifteeBoxConfigUrlCode: UrlCode
  ) => {
    const projectUrlCode = state.selectedProjectUrlCode;
    const url = `/console/projects/${projectUrlCode}/${ProjectContents.GIFTEE_BOX_CONFIGS}/${gifteeBoxConfigUrlCode}/${ProjectContents.EXCHANGE_REPORT}`;
    navigate(url);
  }
});

const mapDispatchToProps = () => ({});

export type BulkTablePropsMappedFromState = ReturnType<typeof mapStateToProps>;

export type BulkTablePropsMappedFromDispatch = ReturnType<
  typeof mapDispatchToProps
>;

export default connect(mapStateToProps, mapDispatchToProps)(BulkTable);
